<div class="card">

<div class="week">
  @if (store.data(); as data) { @for (day of data.days; track day.date; let i = $index) {
  <div
    class="week__cell"
    [ngClass]="{'week__sep': i !== data.days.length - 1}"
    role="button"
    tabindex="0"
    (click)="select(i)"
    (keyup.enter)="select(i)"
    (keyup.space)="select(i)"
    [attr.aria-pressed]="store.selectedDayIdx() === i"
  >
    <dr-flex-home-ui-day-tile class="week__cell-width" [day]="day" [label]="labelFor(day.date, i)" [unit]="store.unit()" [active]="store.selectedDayIdx() === i">
    </dr-flex-home-ui-day-tile>
  </div>
  } }
</div>
</div>

